module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr3-392feb9d55681404275136be9ba4bab2.jpg";